import { TKeys } from './types'

export const nl_nl: Record<TKeys, string> = {
  ...require('./en-en').en_en, // TODO
  // SCREENS
  // Algemeen
  loading: 'Laden...',
  // SignIn
  signin_title: 'Aanmelden',
  signin_redirect_title: 'Controleer je gebruikersnaam en wachtwoord',
  psw_placeholder_redirect: 'Bevestig wachtwoord',
  psw_placeholder: 'Wachtwoord',
  email_placeholder: 'E-mailadres',
  language: 'Taal',
  forgot_password: 'Wachtwoord vergeten?',
  signup_hint: 'Geen account? Meld je aan',
  btn_signin: 'Inloggen',
  // Intro
  // N-Ary sort
  my_profile: 'Mijn profiel',
  btn_submit: 'Indienen',
  btn_finish: 'Eindigen',
  hint_undo: 'Weet je zeker dat je je laatste actie ongedaan wilt maken?',
  // Global screen
  tip_quit: 'Weet je zeker dat je wilt stoppen?',
  // State screen
  intro_title: 'Geluk is de sleutel tot succes',
  intro_body: `Als je houdt van wat je doet en van het team waarmee je werkt, zul je succesvol zijn in je professionele leven.`,
  howto1_title: `Je krijgt 2 uitspraken te zien
  
  Kies degene die je het meest aanspreekt

  Dit kost slechts 12 minuten`,
  howto1_body: 'We raden aan deze test uit te voeren in een rustige omgeving. Doe het indien nodig later.',
  award1_title: 'Goed gedaan!',
  award1_body: `Bovenaan de volgende lijst staan de elementen die je het belangrijkste vindt in je ideale werkomgeving. Je kunt de volgorde van de uitspraken aanpassen door ze te verslepen.`,
  award2_title: 'Je bent al over de helft!',
  award2_body: `Bovenaan de volgende lijst staan de elementen die je het belangrijkste vindt in je ideale werkomgeving. Je kunt de volgorde van de uitspraken aanpassen door ze te verslepen.`,
  award3_title: 'Gefeliciteerd met het derde deel',
  award3_body: `Bovenaan de volgende lijst staan de elementen die je het belangrijkste vindt in je ideale werkomgeving. Je kunt de volgorde van de uitspraken aanpassen door ze te verslepen.`,
  howto2_title: 'En nu de laatste stap - ±2 minuten',
  howto2_body: `Kun je de volgende stellingen ordenen van belangrijkst (bovenaan) naar minst belangrijkst (onderaan).`,
  title_rank: 'In jouw **IDEALE** werkomgeving ...',
  subtitle_rank_2: 'wat vind jij het belangrijkst?',
  subtitle_rank_n: 'Waar zou u de volgende uitspraak plaatsen?',
  hint_reorder: 'Pas de volgorde aan van meest naar minst belangrijk',
  hint_overview: 'Klik hieronder om het overzicht te bekijken',
  hint_profile: 'Mijn huidige voorkeuren',
  hint_place_below: 'Plaats de verklaring hieronder',
  title_rank_bucket: 'Wat is het belangrijkste voor jou?',
  subtitle_rank_best: 'Welke is het BELANGRIJKSTE voor u?',
  subtitle_rank_least: 'Welke is het MINST belangrijk voor u?',
  subtitle_rank_reorder: 'Rangschik van MEEST naar MINST belangrijk',
  title_thanks: 'Bedankt!',
  hint_thanks: 'We hebben je profiel goed ontvangen.',
  title_error: 'We kunnen je gegevens niet versturen',
  hint_error: 'Probeer het later opnieuw ...',
  hint_error_validation: 'Er is een validatiefout opgetreden, probeer het later opnieuw',
  hint_error_dup: 'Je hebt al een eerder rapport ingediend.',
  hint_confirm_round: 'Weet je zeker dat je deze volgorde wilt bevestigen?',
  retry_btn: 'Retry',
  btn_to_overview: 'OVERZICHT',
  btn_to_bucket_x: 'EMMER',
  btn_to_params: 'PARAMETERS',
  btn_open: 'OPENEN',
  btn_start: 'STARTEN',
  btn_confirm: 'BEVESTIGEN',
  // btn_next: 'NEXT'
  btn_next: '>',
  btn_next_str: 'VOLGENDE',
  btn_next_round: 'VOLGENDE STAP',
  // 'btn_prev': 'VORIGE',
  btn_prev: '<',
  btn_cancel: 'ANNULEREN',
  // 'btn_back': 'TERUG',
  btn_back: '<',
  btn_download: 'Download je rapport',
  btn_quit: 'AFSLUITEN',
  // Comparisons
  pick_best: 'Wat is het belangrijkste voor jou?',
  pick_worst: 'Wat is het minst belangrijk voor jou?',
  vs: 'OF',
  // UI elements
  round: 'Stap',
  stm: 'Stelling',
  bucket: 'Emmer',
  axis_y: 'Aantal Verklaringen',
  tip_saved: 'Opgeslagen',
  top_scale_hint: '**Meest belangrijk**',
  bottom_scale_hint: 'Het **Minst belangrijk**',
  pick_tip: 'Gekozen!',
  how_to_binary_title: 'Instructies',
  // values
  samen: 'Samenwerking',
  conf: 'Conformiteit',
  erken: 'Erkenning',
  zorg: 'Zorg',
  gelijk: 'Gelijkheid & diversiteit',
  zelfsturing: 'Zelfsturing',
  macht: 'Macht',
  voorspelbaar: 'Voorspelbaarheid',
  prestatie: 'Prestatiegerichtheid',
  zelfontplooi: 'Zelfontplooiing',
  duurzaam: 'Duurzaamheid',
  integriteit: 'Integriteit',
  innovatie: 'Innovatie',
  daadkracht: 'Daadkracht',
  //
  no_slug_error: 'Controleer of je de juiste link hebt gevolgd. Als dat het geval is, neem dan contact op met de beheerder',
  unknown_error: 'Er is een onbekende fout opgetreden, probeer het later opnieuw',
  invalid_credentials: 'Ongeldige combinatie e-mail / wachtwoord',
  // 360
  // TLTM Scale
  lvl0: 'Kies een waarde',
  lvl1: 'Veel te weinig',
  lvl2: 'Te weinig',
  lvl3: 'Eerder te weinig',
  lvl4: 'Precies genoeg',
  lvl5: 'Eerder te veel',
  lvl6: 'Te veel',
  lvl7: 'Veel te veel',
  lvlx1: '-3',
  lvlx2: '-2',
  lvlx3: '-1',
  lvlx4: 'Precies genoeg',
  lvlx5: '+1',
  lvlx6: '+2',
  lvlx7: '+3',
  // SCALE 10 lvlSC10x
  lvlSC10x00: 'Selecteer',
  lvlSC10x00e: '🤔',
  //
  lvlSC10x0e: '😫',
  lvlSC10x0nps: 'Nooit',
  lvlSC10x0: 'Nul',
  lvlSC10x1e: '😖',
  lvlSC10x1nps: 'MISSING',
  lvlSC10x1: 'Uiterst slecht',
  lvlSC10x2e: '😣',
  lvlSC10x2nps: 'MISSING',
  lvlSC10x2: 'Zeer slecht',
  lvlSC10x3e: '😠',
  lvlSC10x3nps: 'MISSING',
  lvlSC10x3: 'Slecht',
  lvlSC10x4e: '🙁',
  lvlSC10x4nps: 'MISSING',
  lvlSC10x4: 'Onvoldoende',
  lvlSC10x5e: '😯',
  lvlSC10x5nps: 'MISSING',
  lvlSC10x5: 'Matig',
  lvlSC10x6e: '😐',
  lvlSC10x6nps: 'MISSING',
  lvlSC10x6: 'Gemiddeld',
  lvlSC10x7e: '🙂',
  lvlSC10x7nps: 'MISSING',
  lvlSC10x7: 'Goed',
  lvlSC10x8e: '😊',
  lvlSC10x8nps: 'MISSING',
  lvlSC10x8: 'Zeer goed',
  lvlSC10x9e: '😃',
  lvlSC10x9nps: 'MISSING',
  lvlSC10x9: 'Uitstekend',
  lvlSC10x10e: '😍',
  lvlSC10x10nps: 'Zeker',
  lvlSC10x10: 'Onberispelijk',
  howto_360_title: `Als organisatie hechten wij veel waarde aan waarden, en we geloven dat het essentieel is om te weten wat je echt gelukkig maakt in je werkomgeving.`,
  howto_360_body: `Deze vragenlijst is en blijft anoniem voor je hiërarchie, die alleen geaggregeerde resultaten zal ontvangen.`,
  picker_360_title_workenv: 'In mijn huidige werkomgeving …',
  picker_360_title_leadership: 'Mijn directe leidinggevende …',
  nps_title: 'Zou je iemand die je kent aanraden om hier te komen werken?',
  comment_title: 'Voeg een opmerking toe',
  comment_placeholder: 'Wij danken u voor alle constructieve feedback over deze verklaring',
  comment_save: 'Opslaan en sluiten',
  comment_remaining: 'character(s) left',
  howto_workenv_title: 'Deel nu je indrukken van je huidige werkomgeving',
  howto_workenv_body: `Hoe leef je het? Denk aan procedures, bestuur, systemen, enz. 
  Aarzel niet om een reactie achter te laten`,
  howto_nps_title: 'Zou je je werkgever aanbevelen als een plek om te werken',
  howto_nps_body: 'Op een schaal van 0 tot 10, hoe waarschijnlijk zou je je werkgever aanbevelen als een plek om te werken aan je vrienden of familie?',
  // legacy_v2:
  btn_next_step: 'Volgende',
  to_assign: 'Nog toe te wijzen',
  least_important: 'Minst belangrijk',
  moderately_important: 'Matig belangrijk',
  most_important: 'Meest belangrijk',
  ranker_title: 'Wat vind jij belangrijk in je ideale baan?',
  too_insufficient_warning: 'Deze groep bevat te weinig stellingen',
  too_much_warning: 'Deze groep bevat te veel stellingen',
  too_much_warning1: 'Je hebt te veel stellingen toegewezen aan de volgende groep(en):',
  too_much_warning2: 'Klik op de groep en verplaats stellingen naar een andere groep totdat de verdeling klopt',
  empty_bin: 'Deze groep is leeg',
  // further_ranking: 'Deel de "{{v2}}" stellingen in 3 categorieën',
  further_ranking: 'Classificeer de {{v1}} {{v2}} stellingen',
  further_ranking1: 'Classificeer verder de {{v1}} {{v2}} stellingen',
  further_ranking2: 'Classificeer ten slotte de {{v1}} {{v2}} stellingen',
  hint_modal_title: 'Stel je ideale werkomgeving voor',
  hint_modal_body1: 'Rangschik 42 stellingen over je ideale omgeving van minst tot meest belangrijk',
  hint_modal_body2_left: 'links',
  hint_modal_body2_left_txt: 'de 11 stellingen die je het minst belangrijk vindt',
  hint_modal_body2_right: 'rechts',
  hint_modal_body2_right_txt: 'de 11 stellingen die je het belangrijkst vindt',
  hint_modal_body2_middle: 'midden',
  hint_modal_body2_middle_txt: 'de 20 stellingen die je matig belangrijk vindt',
  hint_modal_body3: 'Sleep en zet elke stelling in de emmer die het beste bij jou past',
  hint_modal_cta: 'Start',
  hint_top: 'Omhoog scrollen',
  hint_down: 'Omlaag scrollen',
  reflect_current_view_sort_body: 'Indien niet, wordt u aangeboden om uw definitieve rangschikking te sorteren',
  yes: 'Ja',
  no: 'Nee',
  final_ranking: 'Eindrangschikking',
  final_distribution_invalid_title: 'De definitieve verdeling is ongeldig',
      final_distribution_invalid_body: 'Er zijn {{v1}} emmer(s) met te veel uitspraken en {{v2}} emmer(s) met te weinig uitspraken',
  no_available_bins_warning: 'Geen beschikbare emmers voor willekeurige toewijzing - alle emmers hebben hun maximale capaciteit bereikt',
  example: 'Voorbeeld :',
} as const
